/* DROP KIT 2 — avis (voir plus), vidéos portées (une à la fois, flou, progression), guide des tailles */
(() => {
  if (window.__lgDrop2) return; window.__lgDrop2 = true;
  const ready = (fn) => (document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn));

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-lg-more]'); if (!btn) return;
    const wall = document.getElementById(btn.dataset.lgMore); if (!wall) return;
    const step = Number(btn.dataset.step) || 8;
    Array.from(wall.querySelectorAll('.lg-rv--hidden')).slice(0, step).forEach((el, i) => {
      el.classList.remove('lg-rv--hidden'); el.classList.add('lg-rv--in'); el.style.animationDelay = (i * 40) + 'ms';
    });
    const left = wall.querySelectorAll('.lg-rv--hidden').length;
    if (!left) btn.closest('.lg-rv-more')?.remove();
    else { const c = btn.querySelector('[data-left]'); if (c) c.textContent = left; }
  });

  const PH_DURATION = 6000;
  function initReels(root = document) {
    root.querySelectorAll('.lg-reels:not([data-init])').forEach((wrap) => {
      wrap.dataset.init = '1';
      const track = wrap.querySelector('.lg-reels__track');
      const reels = Array.from(wrap.querySelectorAll('.lg-reel'));
      if (!track || !reels.length) return;
      let idx = 0, inView = false, phTimer = null, phStart = 0, phElapsed = 0, programmatic = false;
      const bar = (r) => r.querySelector('.lg-reel__bar i');
      const vid = (r) => r.querySelector('video');
      const stopPh = () => { if (phTimer) { cancelAnimationFrame(phTimer); phTimer = null; } };
      const runPh = (r) => {
        stopPh(); phStart = performance.now() - phElapsed;
        const step = (now) => {
          phElapsed = now - phStart;
          const p = Math.min(1, phElapsed / PH_DURATION);
          const b = bar(r); if (b) b.style.width = (p * 100) + '%';
          if (p >= 1) { phElapsed = 0; go(idx + 1, true); return; }
          phTimer = requestAnimationFrame(step);
        };
        phTimer = requestAnimationFrame(step);
      };
      const scrollToReel = (r) => {
        const tl = track.scrollLeft, tw = track.clientWidth, rl = r.offsetLeft - track.offsetLeft, rw = r.offsetWidth;
        if (rl < tl || rl + rw > tl + tw) { programmatic = true; track.scrollTo({ left: rl, behavior: 'smooth' }); setTimeout(() => (programmatic = false), 700); }
      };
      const playActive = () => {
        const r = reels[idx]; const v = vid(r);
        if (!inView) { if (v) v.pause(); stopPh(); return; }
        if (v) { v.play().catch(() => {}); } else { runPh(r); }
      };
      function go(i, autoScroll) {
        const n = (i + reels.length) % reels.length;
        if (n !== idx) {
          const old = reels[idx]; const ov = vid(old);
          if (ov) { ov.pause(); try { ov.currentTime = 0; } catch (e) {} }
          const ob = bar(old); if (ob) ob.style.width = '0%';
          stopPh(); phElapsed = 0;
        }
        idx = n;
        reels.forEach((r, j) => r.classList.toggle('is-active', j === idx));
        if (autoScroll) scrollToReel(reels[idx]);
        playActive();
      }
      reels.forEach((r, j) => {
        const v = vid(r);
        if (v) {
          v.loop = false; v.muted = true; v.defaultMuted = true; v.playsInline = true; v.removeAttribute('autoplay'); v.removeAttribute('controls');
          v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
          /* iPhone : ne jamais passer en plein écran tout seul */
          v.addEventListener('webkitbeginfullscreen', () => { try { v.webkitExitFullscreen(); } catch (e) {} });
          v.addEventListener('timeupdate', () => { const b = bar(r); if (b && v.duration) b.style.width = (v.currentTime / v.duration * 100) + '%'; });
          v.addEventListener('ended', () => { if (j === idx) go(idx + 1, true); });
        }
        r.addEventListener('click', (e) => {
          if (e.target.closest('.lg-reel__sound, a')) return;
          if (j !== idx) { go(j, true); return; }
          if (v) { v.paused ? v.play().catch(() => {}) : v.pause(); }
        });
        const snd = r.querySelector('.lg-reel__sound');
        if (snd && v) snd.addEventListener('click', () => {
          reels.forEach((o) => { const ov = vid(o); if (ov && ov !== v) ov.muted = true; });
          v.muted = !v.muted; snd.setAttribute('aria-pressed', String(!v.muted)); snd.classList.toggle('is-on', !v.muted);
          if (j !== idx) go(j, true);
        });
      });
      wrap.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', () => go(idx + Number(b.dataset.dir), true)));
      let st;
      track.addEventListener('scroll', () => {
        if (programmatic) return;
        clearTimeout(st);
        st = setTimeout(() => {
          const left = track.scrollLeft; let best = 0, dist = Infinity;
          reels.forEach((r, j) => { const d = Math.abs((r.offsetLeft - track.offsetLeft) - left); if (d < dist) { dist = d; best = j; } });
          if (best !== idx) go(best, false);
        }, 140);
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => { inView = en.isIntersecting; playActive(); }, { threshold: 0.35 }).observe(wrap);
      } else { inView = true; }
      go(0, false);
    });
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-lg-finder]'); if (!form) return;
    e.preventDefault();
    const h = Number(form.querySelector('[name=h]').value), w = Number(form.querySelector('[name=w]').value);
    const fit = Number((form.querySelector('[name=fit]:checked') || {}).value || 0);
    let rows = []; try { rows = JSON.parse(form.dataset.table); } catch (err) {}
    const out = form.parentElement.querySelector('[data-lg-result]');
    if (!rows.length || !h || !w) return;
    const find = (val, key) => { const i = rows.findIndex((r) => val <= r[key]); return i === -1 ? rows.length - 1 : i; };
    let i = Math.max(find(h, 'h'), find(w, 'w')) + fit;
    i = Math.min(rows.length - 1, Math.max(0, i));
    const size = rows[i].size;
    out.hidden = false;
    out.querySelector('[data-size]').textContent = size;
    const pick = out.querySelector('[data-pick]'); pick.dataset.pick = size; pick.textContent = (pick.dataset.label || 'Choisir la taille') + ' ' + size;
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pick]'); if (!b || !b.dataset.pick) return;
    const size = b.dataset.pick;
    const scope = b.closest('.product-information, product-information, main') || document;
    const inputs = Array.from(scope.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]'));
    const match = inputs.find((i) => (i.value || '').trim().toLowerCase() === size.toLowerCase());
    if (match) { match.click(); }
    else {
      const sel = Array.from(scope.querySelectorAll('variant-picker select option, .variant-picker select option')).find((o) => o.value.trim().toLowerCase() === size.toLowerCase());
      if (sel) { sel.selected = true; sel.parentElement.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    b.closest('dialog')?.close();
  });

  const initAll = (root) => { initReels(root); };
  ready(() => initAll(document));
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => { if (e.target.classList && e.target.classList.contains('lg-rv--hidden')) e.target.classList.remove('lg-rv--hidden'); });
})();
